import React from 'react';
import styled from 'styled-components';
import { ASSET_KEY, assetSource } from 'shared/utils/assetSource';
import { getText, TEXT_KEY } from 'shared/utils/localization';
import { numberWithCommas } from 'shared/utils/number';

const PiggyBankAmount = ({ isBroken, oldPurchasedVales, coinsAmount, loyaltyPoints = 0 }) => {
  const currentCoinValue = isBroken ? oldPurchasedVales?.coinsAmount ?? coinsAmount : coinsAmount;
  const currentLoyaltyPoints = isBroken ? oldPurchasedVales?.loyaltyPoints ?? loyaltyPoints : loyaltyPoints;
  const formattedCoinValue = numberWithCommas(currentCoinValue);
  const formattedLoyaltyPoints = numberWithCommas(currentLoyaltyPoints);
  const totalLength = String(currentCoinValue).length + String(currentLoyaltyPoints).length;
  const fontSize = totalLength > 17 ? '3.5dvw' : totalLength > 11 ? '4dvw' : '5dvw';
  return (
    <CoinsWrapper>
      <CoinIcon src={assetSource(ASSET_KEY.COIN_ICON)} alt="Coin Icon" />
      <InfoText fontSize={fontSize} data-text={formattedCoinValue}>
        <span>{formattedCoinValue}</span>
      </InfoText>
      {currentLoyaltyPoints > 0 && (
        <>
          <InfoText fontSize={fontSize} data-text={getText(TEXT_KEY.PLUS_SYMBOL)} style={{ marginLeft: '0.5dvw' }}>
            <span>{getText(TEXT_KEY.PLUS_SYMBOL)}</span>
          </InfoText>
          <LoyaltyIcon src={assetSource(ASSET_KEY.LOYALTY_ICON)} alt="Loyalty Icon" />
          <InfoText fontSize={fontSize} data-text={formattedLoyaltyPoints}>
            <span>{formattedLoyaltyPoints}</span>
          </InfoText>
        </>
      )}
    </CoinsWrapper>
  );
};

export default PiggyBankAmount;

const CoinsWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  top: 7.5dvw;
  position: absolute;
  ${({ theme }) => theme.PiggyBankAmount.CoinsWrapper}
`;

const CoinIcon = styled.img`
  position: relative;
  width: 3dvw;
  height: auto;
  margin: 0 0.5vw 0 0;
  top: 1px;
  ${({ theme }) =>
    theme.screens.device('mobile-browser') &&
    `
    width: 2.6dvw;
    `}
  ${({ theme }) => theme.PiggyBankAmount.CoinIcon}
`;

const LoyaltyIcon = styled.img`
  position: relative;
  width: 5dvw;
  height: auto;
  margin: -0.5vw -0.5vw 0 0;
  top: 1px;
  ${({ theme }) =>
    theme.screens.device('mobile-browser') &&
    `
    width: 4.6dvw;
    `}
  ${({ theme }) => theme.PiggyBankAmount.LoyaltyIcon}
`;

export const InfoText = styled.h1`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 700;
  font-size: ${({ fontSize }) => fontSize};
  filter: drop-shadow(0px 3px 1px #980326) drop-shadow(0px 8px 2px rgba(0, 0, 0, 0.2));

  ${({ theme }) =>
    theme.screens.device('mobile-browser') &&
    `
    font-size: 3.5dvw;
    `}

  span {
    letter-spacing: 1px;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    background: linear-gradient(to bottom, #fff, #ffd22d, #ff7400);
    -webkit-background-clip: text;
    background-clip: text;
    -webkit-text-fill-color: transparent;

    &::before {
      content: attr(data-text);
      position: absolute;
      top: 0;
      left: 0;
      z-index: -1;
      background: linear-gradient(to bottom, #fff, #ffd22d, #ff7400);
      -webkit-background-clip: text;
      background-clip: text;
      -webkit-text-fill-color: transparent;
      filter: blur(4px);
      opacity: 0.8;
    }
    &::after {
      content: attr(data-text);
      position: absolute;
      top: 0;
      left: 0;
      z-index: -2;
      -webkit-text-stroke: 2px #fffae0;
      color: transparent;
    }
  }
`;

